<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center justify-content-between text-white" style="padding: 32px 0;">
            <div class="d-flex align-items-center">
              <div class="header-icon-wrap mr-3">
                <i class="fe fe-users" style="font-size: 22px;"></i>
              </div>
              <div>
                <h4 class="mb-0 font-weight-bold">Manage Enrollees</h4>
                <small style="opacity: 0.8;">
                  <span v-if="clients && clients.meta">
                    {{ clients.meta.total | numeral(0, 0) }} enrollees registered
                  </span>
                  <span v-else>Loading…</span>
                </small>
              </div>
            </div>
            <button class="btn header-add-btn" @click="show = !show">
              <i class="fe mr-1" :class="show ? 'fe-x' : 'fe-user-plus'"></i>
              {{ show ? 'Cancel' : 'Add Enrollee' }}
            </button>
          </div>
        </div>
      </div>

      <section style="margin-top: -20px;">
        <div class="container pb-5">

          <!-- ── Search & Filter sub-components ── -->
          <!-- <SearchUser /> -->
          <!-- <FilterUserProvider /> -->

          <!-- ── Add Enrollee Form (collapsible) ── -->
          <div v-show="show" class="card shadow-sm form-card mb-4">
            <div class="form-card-header">
              <div class="section-number">
                <i class="fe fe-user-plus" style="font-size: 12px;"></i>
              </div>
              <h6 class="mb-0 font-weight-bold text-white">New Enrollee</h6>
              <button class="btn btn-sm ml-auto"
                style="background: rgba(255,255,255,0.15); color:#fff; border-radius:6px;" @click="show = false">
                <i class="fe fe-x"></i>
              </button>
            </div>
            <div class="card-body px-4 py-4">
              <AddClientForm />
            </div>
          </div>

          <!-- ── Enrollees Table ── -->
          <div class="card shadow-sm table-card">
            <div class="form-card-header">
              <div class="section-number">
                <i class="fe fe-list" style="font-size: 12px;"></i>
              </div>
              <h6 class="mb-0 font-weight-bold text-white">Enrollees</h6>
              <span v-if="clients && clients.meta" class="badge badge-light ml-auto" style="border-radius: 20px;">
                {{ clients.meta.total | numeral(0, 0) }} total
              </span>
            </div>

            <div class="table-responsive">
              <table class="table align-td-middle mb-0">
                <thead style="background: #f8fafc;">
                  <tr>
                    <th class="table-th">#</th>
                    <th class="table-th">Enrollee</th>
                    <th class="table-th">Phone</th>
                    <th class="table-th">Sector</th>
                    <th class="table-th">ID Number</th>
                    <th class="table-th"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(client, index) in clients.data" :key="client.id" class="table-row">
                    <td class="px-4 py-3 text-muted small">{{ index + 1 }}</td>
                    <td class="py-3">
                      <div class="d-flex align-items-center" style="gap: 10px;">
                        <div v-if="client.user_image" class="enrollee-avatar">
                          <img :src="`https://claimify-api.hayokmedicare.ng/image/${client.user_image}`"
                            class="rounded-circle" style="width: 36px; height: 36px; object-fit: cover;" />
                        </div>
                        <div v-else class="enrollee-avatar-initials">
                          {{ initials(client.firstname, client.lastname) }}
                        </div>
                        <div>
                          <p class="mb-0 font-weight-bold" style="font-size: 0.86rem;">
                            {{ client.firstname }} {{ client.lastname }}
                          </p>
                          <small class="text-muted">{{ client.email }}</small>
                        </div>
                      </div>
                    </td>
                    <td class="py-3" style="font-size: 0.85rem;">{{ client.phone_number }}</td>
                    <td class="py-3">
                      <span class="sector-badge">{{ client.sector }}</span>
                    </td>
                    <td class="py-3">
                      <span class="id-chip">{{ client.id_card_number }}</span>
                    </td>
                    <td class="py-3 pr-4">
                      <router-link :to="{ path: '/client/' + client.id }">
                        <button class="btn btn-sm btn-outline-primary">
                          <i class="fe fe-eye mr-1"></i>
                        </button>
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="!clients || !clients.data || !clients.data.length">
                    <td colspan="6" class="text-center py-5 text-muted">
                      <i class="fe fe-inbox" style="font-size: 2rem; opacity: 0.3;"></i>
                      <p class="mt-2 mb-0">No enrollees found</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Pagination -->
            <div v-if="clients && clients.meta" class="d-flex align-items-center justify-content-between px-4 py-3"
              style="border-top: 1px solid #f1f5f9;">
              <small class="text-muted">
                Page {{ clients.meta.current_page }} of {{ clients.meta.last_page }}
              </small>
              <div class="d-flex" style="gap: 8px;">
                <button class="btn btn-sm btn-outline-secondary" @click="gotoPrevious"
                  :disabled="clients.meta.current_page == 1">
                  <i class="fe fe-chevron-left mr-1"></i> Previous
                </button>
                <button class="btn btn-sm btn-outline-secondary" @click="gotoNext"
                  :disabled="clients.meta.current_page == clients.meta.last_page">
                  Next <i class="fe fe-chevron-right ml-1"></i>
                </button>
              </div>
            </div>
          </div>

        </div>
      </section>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";
  import AddClientForm from "@/views/clients/AddClientForm.vue";
  // import SearchUser from "@/views/shis/component/SearchUser.vue";
  // import FilterUserProvider from "@/views/shis/component/FilterUserProvider.vue";
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";

  export default {
    components: { Navbar, Loading, AddClientForm },
    data() {
      return {
        isLoading: false,
        fullPage: true,
        states: "",
        show: false,
        clients: { data: [], meta: null },
        providers: "",
        sector: "",
        mdas: "",
        wards: [],
        state: "",
        lga_states: "",
        current_page: 1,
        register: {
          firstname: "", lastname: "", middlename: "", nimc_number: "",
          email: "", phone_number: "", type: "client", agency_id: "",
          state: "", localgovt: "", ward: "", address: "", blood: "",
          weight: "", gender: "", genotype: "", dob: "", salary_number: "",
          provider_id: "", point_of_care: "", sector: "", finger_print: "",
          place_of_work: "", grade_level: "", date_of_entry: "",
          marital_status: "", category_of_vulnerable_group: "",
        },
      };
    },
    beforeMount() {
      this.isLoading = true;
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/getAgencyToUser/${this.user.institutional_id}`, {
          params: { page: this.current_page },
        })
        .then((response) => {
          this.clients = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },
    methods: {
      initials(first, last) {
        return ((first || '').charAt(0) + (last || '').charAt(0)).toUpperCase();
      },
      fetchWards() {
        this.axios
          .get(`/api/v1/auth/getwards/` + event.target.value)
          .then((response) => { this.wards = response.data.data; })
          .catch((error) => { console.error(error); });
      },
      gotoNext() {
        if (this.clients.meta.current_page != this.clients.meta.last_page) {
          this.current_page++;
          this.getClients();
        } else {
          this.$toasted.info("You have reached the Last Page", { position: "top-center", duration: 3000 });
        }
      },
      gotoPrevious() {
        if (this.clients.meta.current_page != 1) {
          this.current_page--;
          this.getClients();
        } else {
          this.$toasted.info("You have reached the First Page", { position: "top-center", duration: 3000 });
        }
      },
      getClients() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.isLoading = true;
        this.axios
          .get(`/api/v1/auth/getAgencyToUser/${this.user.institutional_id}`, {
            params: { page: this.current_page },
          })
          .then((response) => {
            this.clients = response.data;
            this.isLoading = false;
          })
          .catch((error) => {
            this.isLoading = false;
            console.error(error);
          });
      },
      getStates() {
        this.axios
          .get(`/api/v1/auth/states`)
          .then((response) => { this.states = response.data.data; })
          .catch((error) => { console.error(error); });
      },
      fetchLga() {
        this.axios
          .get(`/api/v1/auth/lga/2669`)
          .then((response) => { this.lga_states = response.data.data; })
          .catch((error) => { console.error(error); });
      },
      getMDAs() {
        this.axios
          .get(`/api/v1/auth/ministry`)
          .then((response) => { this.mdas = response.data.data; })
          .catch((error) => { console.error(error); });
      },
      registerUser() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.isLoading = true;
        this.axios
          .post("/api/v1/auth/registerProvider", {
            agency_id: this.user.institutional_id,
            nimc_number: this.register.nimc_number,
            firstname: this.register.firstname,
            lastname: this.register.lastname,
            middlename: this.register.middlename,
            email: this.register.email,
            phone_number: this.register.phone_number,
            type: this.register.type,
            provider_id: this.register.provider_id,
            state: "2669",
            role: 0,
            password: "jacobi",
            localgovt: this.register.localgovt,
            ward: this.register.ward,
            blood: this.register.blood,
            dob: this.register.dob,
            address1: this.register.address,
            genotype: this.register.genotype,
            weight: this.register.weight,
            gender: this.register.gender,
            sector: this.register.sector,
            place_of_work: this.register.place_of_work,
            point_of_care: this.register.point_of_care,
            finger_print: this.register.finger_print,
            salary_number: this.register.salary_number,
            grade_level: this.register.grade_level,
            date_of_entry: this.register.date_of_entry,
            marital_status: this.register.marital_status,
            category_of_vulnerable_group: this.register.category_of_vulnerable_group,
            enrolled_by: this.user.id,
          })
          .then((response) => {
            this.isLoading = false;
            this.getClients();
            this.show = false;
            this.$toasted.success("Enrollee added successfully", { position: "top-center", duration: 3000 });
            this.$router.push(`/client/${response.data.data.id}`);
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
            this.$toasted.error("Something went wrong", { position: "top-center", duration: 3000 });
          });
      },
      getProviders() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/providerAgency/${this.user.institutional_id}`)
          .then((response) => { this.providers = response.data.data; })
          .catch((error) => { console.error(error); });
      },
    },
    created() {
      this.fetchLga();
      this.getClients();
      this.getMDAs();
      this.getProviders();
    },
  };
</script>

<style scoped>
  .page-header {
    background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
    padding-bottom: 40px;
  }

  .header-icon-wrap {
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .header-add-btn {
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: #fff;
    border-radius: 8px;
    font-weight: 600;
    font-size: 0.85rem;
    padding: 8px 18px;
    transition: background 0.15s;
  }

  .header-add-btn:hover {
    background: rgba(255, 255, 255, 0.25);
    color: #fff;
  }

  .form-card,
  .table-card {
    border-radius: 12px;
    border: 1px solid #e9ecef;
    overflow: hidden;
  }

  .form-card-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 20px;
    background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  }

  .section-number {
    width: 28px;
    height: 28px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    flex-shrink: 0;
  }

  .table-th {
    font-size: 0.73rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #64748b;
    font-weight: 600;
    border-bottom: 2px solid #e2e8f0;
    padding: 12px 16px;
  }

  .table-row:hover {
    background: #f8fafc;
  }

  .enrollee-avatar {
    flex-shrink: 0;
  }

  .enrollee-avatar-initials {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: linear-gradient(135deg, #e8f0fe, #c7d7ff);
    color: #2563eb;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 0.78rem;
    flex-shrink: 0;
  }

  .sector-badge {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 20px;
    background: #f0f4ff;
    color: #3730a3;
    font-size: 0.72rem;
    font-weight: 600;
    white-space: nowrap;
  }

  .id-chip {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 6px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    font-size: 0.78rem;
    font-family: monospace;
    color: #475569;
    white-space: nowrap;
  }

  .form-control:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 0.15rem rgba(37, 99, 235, 0.15);
  }
</style>